module.exports = __webpack_public_path__ + "img/jingbao3.gif";